interface SalesData {
  totalSales: number;
  monthlySales: number;
  weeklySales: number;
  dailySales: number;
}

interface SalesCardProps {
  salesData: SalesData;
}

const SalesCard: React.FC<SalesCardProps> = ({ salesData }) => {
  const formatAmount = (value: number) => {
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(value || 0);
  };

  return (
    <div className="rounded-sm border border-stroke bg-white py-6 px-7.5 shadow-default dark:border-strokedark dark:bg-boxdark hover:shadow-lg transition-shadow duration-200 cursor-pointer">
      <div className="mx-2">
        <div>
          <span className="text-sm font-medium">Sales Overview</span>
        </div>
        
        <div className="mt-3 grid grid-cols-2 gap-2">
          <div className="text-left">
            <h5 className="text-sm font-semibold text-green-600 dark:text-green-400">
              {formatAmount(salesData.monthlySales)}
            </h5>
            <span className="text-xs text-gray-600 dark:text-gray-400">
              Monthly
            </span>
          </div>
          
          <div className="text-left">
            <h5 className="text-sm font-semibold text-purple-600 dark:text-purple-400">
              {formatAmount(salesData.weeklySales)}
            </h5>
            <span className="text-xs text-gray-600 dark:text-gray-400">
              Weekly
            </span>
          </div>
          
          <div className="text-left">
            <h5 className="text-sm font-semibold text-orange-600 dark:text-orange-400">
              {formatAmount(salesData.dailySales)}
            </h5>
            <span className="text-xs text-gray-600 dark:text-gray-400">
              Daily
            </span>
          </div>
          
          <div className="text-left">
            <h5 className="text-sm font-semibold text-blue-600 dark:text-blue-400">
              {formatAmount(salesData.totalSales)}
            </h5>
            <span className="text-xs text-gray-600 dark:text-gray-400">
              All Time
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SalesCard;